import PhoneNumberField from 'components/consumer/checkout/desktop/components/Shipping/components/PhoneNumberField';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Radio from 'components/essentials/Radio';

const preferredContactTime = ['Morning', 'Afternoon', 'Evening'];
const preferredContactTimeZone = ['Eastern', 'Central', 'Mountain', 'Pacific'];

const PreferredContactTimeChoices = ({
  onChange,
  options,
  optionName,
  label,
  selectedValue,
}) => {
  const choices = options.map(element => (
    <div>
      <Radio
        name={`${optionName}-${element}`}
        checked={selectedValue === element}
        onChange={() => onChange(optionName, element)}
      >
        {element}
      </Radio>
    </div>
  ));
  return (
    <>
      <div className="font-bold text-base mb-2">{label}</div>
      <div className="flex flex-wrap gap-x-3 ml-2">{choices}</div>
    </>
  );
};

const CustomerContactOption = ({ onChange, yearsSinceOrderDelivered = 0 }) => {
  const [contactOption, setContactOption] = useState('email');

  const [phonePreferredTime, setPhonePreferredTime] = useState({
    phoneNumber: '',
    preferredContactTime: preferredContactTime[0],
    preferredContactTimeZone: preferredContactTimeZone[0],
  });

  const handlePhoneNumberChange = e => {
    const timeSelection = phonePreferredTime;
    timeSelection.phoneNumber = e.target.value;
    setPhonePreferredTime(timeSelection);
    onChange({ phone: timeSelection });
  };

  const handlePreferredContactChange = (optionName, value) => {
    phonePreferredTime[optionName] = value;
    setPhonePreferredTime(phonePreferredTime);
    onChange({ phone: phonePreferredTime });
  };

  return (
    <div className="CustomerContactOption mt-4">
      <p className="font-bold text-base mb-2">
        How would you like us to contact you?
      </p>

      <div className="flex flex-row items-center gap-3">
        <Radio
          name="contact-option"
          checked={contactOption === 'email'}
          onChange={() => {
            onChange(null);
            setContactOption('email');
          }}
        >
          Email
        </Radio>

        <Radio
          name="contact-option"
          checked={contactOption === 'phone'}
          onChange={() => {
            setContactOption('phone');
            onChange({ phone: phonePreferredTime });
          }}
        >
          Phone
        </Radio>
      </div>

      {contactOption === 'phone' && (
        <PhoneNumberField
          value={phonePreferredTime.phoneNumber}
          handleChange={handlePhoneNumberChange}
          handleBlur={handlePhoneNumberChange}
          placeholder="Phone number"
        />
      )}
      {contactOption === 'phone' && yearsSinceOrderDelivered < 11 && (
        <div>
          <PreferredContactTimeChoices
            onChange={handlePreferredContactChange}
            options={preferredContactTime}
            optionName="preferredContactTime"
            label="What is your preferred contact time?"
            selectedValue={phonePreferredTime.preferredContactTime}
          />
          <PreferredContactTimeChoices
            onChange={handlePreferredContactChange}
            options={preferredContactTimeZone}
            optionName="preferredContactTimeZone"
            label="What timezone are you located in?"
            selectedValue={phonePreferredTime.preferredContactTimeZone}
          />
        </div>
      )}
    </div>
  );
};

CustomerContactOption.propTypes = {
  onChange: PropTypes.func.isRequired,
  yearsSinceOrderDelivered: PropTypes.number,
};

export default CustomerContactOption;
